module.exports = __webpack_public_path__ + "img/filter-arrow.4f4ca067.svg";